// extracted by mini-css-extract-plugin
module.exports = {"search":"searchStyles-module__search___1gfSY"};